import React from 'react';
import { FaTwitter, FaInstagram, FaYoutube } from 'react-icons/fa';

const SocialIcons = () => {
    return (
        <div 
            className="flex gap-8 ml-5 mt-5 sm:ml-10 sm:mt-4 md:ml-10 md:mt-6 lg:ml-20 lg:mt-8"
        >
            <a 
                href="https://x.com/akoifoundation" 
                target="_blank" 
                rel="noopener noreferrer" 
                className="hover:text-red-600"
            >
                <FaTwitter size={30} />
            </a>
            <a 
                href="https://www.instagram.com/akoi.foundation" 
                target="_blank" 
                rel="noopener noreferrer" 
                className="hover:text-red-600"
            >
                <FaInstagram size={30} />
            </a>
            <a 
                href="https://www.youtube.com/@akoifoundation?si=VaxigbN-qitYRZxc" 
                target="_blank" 
                rel="noopener noreferrer" 
                className="text-white hover:text-red-600"
            >
                <FaYoutube size={30} />
            </a>
        </div>
    );
};

export default SocialIcons;
